import { Quote, Volume2 } from 'lucide-react';
import ScrollReveal from '@/components/shared/ScrollReveal';

const testimonials = [
  {
    src: `${__BASE_PATH__}assets/depoimentos/depoimento-1.mp4`,
    label: 'Depoimento Cliente Comercial',
  },
  {
    src: `${__BASE_PATH__}assets/depoimentos/depoimento-2.mp4`,
    label: 'Depoimento Cliente Condomínio',
  },
  {
    src: `${__BASE_PATH__}assets/depoimentos/depoimento-3.mp4`,
    label: 'Depoimento Cliente Restaurante',
  },
];

export default function TestimonialsSection() {
  return (
    <section id="depoimentos" className="immersive-panel bg-background-50">
      <div className="absolute inset-0 bg-radial-green pointer-events-none opacity-30" />

      <div className="immersive-inner">
        <ScrollReveal className="mx-auto mb-10 max-w-3xl text-center md:mb-12">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100 px-4 py-1.5 text-sm font-semibold text-primary-700">
            <Quote className="h-4 w-4" />
            Depoimentos
          </span>
          <h2 className="font-heading text-3xl font-extrabold leading-[1.1] tracking-tighter text-foreground-950 md:text-4xl lg:text-5xl">
            Experiências de quem faz parte da <span className="text-gradient">iGreen</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            Assista aos depoimentos e conheça histórias de pessoas que vivem o ecossistema iGreen.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 justify-items-center gap-6 md:grid-cols-3 md:gap-5 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <ScrollReveal
              key={testimonial.src}
              className="w-full max-w-[23rem]"
              delay={index * 120}
            >
              <article className="overflow-hidden rounded-3xl border border-background-800/60 bg-background-950 p-2.5 shadow-xl shadow-background-950/10 transition-transform duration-300 hover:-translate-y-1">
                <video
                  className="aspect-[9/16] w-full rounded-[1.15rem] bg-black object-contain"
                  controls
                  preload="metadata"
                  playsInline
                  aria-label={testimonial.label}
                >
                  <source src={testimonial.src} type="video/mp4" />
                  Seu navegador não oferece suporte à reprodução deste vídeo.
                </video>
                <div className="flex items-center justify-between gap-3 px-3 pb-2 pt-4">
                  <div className="flex items-center gap-2">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                      <Quote className="h-4 w-4" />
                    </span>
                    <h3 className="text-base font-semibold text-white">{testimonial.label}</h3>
                  </div>
                  <Volume2 className="h-4 w-4 text-foreground-500" aria-hidden="true" />
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
